import "./PrivacyPolicy.module.css";
import Header from "@/reusable_sections/Header";
import HeroVideoBanner from "./sections/HeroVideoBanner";
import Material from "./sections/Material";
import WhatWeDo from "./sections/WhatWeDo";
import GuidingPrinciples from "./sections/GuidingPrinciples";
import OurStudio from "./sections/OurStudio";
import Footer from "@/reusable_sections/Footer";
export default function PrivacyPolicyPage() {
  return <div>
      <Header />
      <HeroVideoBanner />
      <Material />
      <WhatWeDo />
      <Material />
      <GuidingPrinciples />
      <OurStudio />
      <Footer />
    </div>;
}